<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目申请</h2>
      <a
        href="javascript:;"
        v-if="hasApplyId"
        @click="$router.back()"
        class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content">
      <el-form
        ref="form"
        label-width="140px"
        class="form"
        style="margin-bottom: -25px"
      >
        <!-- <el-form-item label="需求类型">
          <el-radio-group
            :disabled="hasApplyId"
            v-model="createType"
            class="type-radio-type"
          >
            <el-radio-button label="object">工程项目需求</el-radio-button>
            <el-radio-button label="ys_object">原水需求</el-radio-button>
            <el-radio-button label="other_object"
              >其他需求(设计/监理/勘测/其他)</el-radio-button
            >
            <el-radio-button label="sm_object"
              >微型项目需求(B类)</el-radio-button
            >
            <el-radio-button label="ys_sm_object"
              >原水微型项目需求(B类)</el-radio-button
            >
            <el-radio-button label="jt_object">集团需求</el-radio-button>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item label="项目类型">
          <el-radio-group v-model="objectType" :disabled="hasApplyId">
            <el-radio-button label="">一般项目</el-radio-button>
            <el-radio-button label="A">微型项目(A类)</el-radio-button>
            <el-radio-button label="B">微型项目(B类)</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="需求类型">
          <el-radio-group
            v-model="createType"
            v-if="objectType != 'B'"
            :disabled="hasApplyId"
          >
            <el-radio-button label="object">工程项目需求</el-radio-button>
            <el-radio-button label="ys_object">原水需求</el-radio-button>
            <el-radio-button label="jt_object">集团需求</el-radio-button>
            <el-radio-button label="other_object"
              >其他需求(设计/监理/勘测/其他)</el-radio-button
            >
          </el-radio-group>
          <el-radio-group v-model="createType" v-else :disabled="hasApplyId">
            <el-radio-button label="sm_object"
              >微型项目需求(B类)</el-radio-button
            >
            <el-radio-button label="ys_sm_object"
              >原水微型项目需求(B类)</el-radio-button
            >
          </el-radio-group>
        </el-form-item>
      </el-form>

      <create1
        :projectArr="projectArr"
        :teamArr="teamArr"
        :objectType="objectType"
        v-if="createType == 'object'"
      ></create1>
      <create2
        :projectArr="projectArr"
        :teamArr="teamArr"
        :objectType="objectType"
        v-if="createType == 'ys_object'"
      ></create2>
      <create3
        :projectArr="projectArr"
        :teamArr="teamArr"
        :objectType="objectType"
        v-if="createType == 'other_object'"
      ></create3>
      <create4
        :projectArr="projectArr"
        :teamArr="teamArr"
        :objectType="objectType"
        v-if="createType == 'sm_object'"
      ></create4>
      <create5
        :projectArr="projectArr"
        :teamArr="teamArr"
        :objectType="objectType"
        v-if="createType == 'ys_sm_object'"
      ></create5>
      <create6
        :projectArr="projectArr"
        :teamArr="teamArr"
        :objectType="objectType"
        v-if="createType == 'jt_object'"
      ></create6>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Create1 from "./create_1";
import Create2 from "./create_2";
import Create3 from "./create_3";
import Create4 from "./create_4";
import Create5 from "./create_5";
import Create6 from "./create_6";
export default {
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      teamArr: [],
      projectArr: [],
      hasApplyId: "",

      // 项目类型
      objectType: "",
      // 需求类型
      createType: "",
    };
  },
  created() {
    this.hasApplyId = this.$route.params.applyId ? true : false;
    this.objectType = "";
    if (this.hasApplyId) {
      ajax.get(
        "/gc/project/apply/info/" + this.$route.params.applyId,
        "",
        (res) => {
          // console.log(res.vo.wxType);
          this.objectType = res.vo.wxType;
          switch (res.vo.type) {
            case "0":
              this.createType = "object";
              break;
            case "1":
              this.createType = "ys_object";
              break;
            case "2":
              this.createType = "other_object";
              break;
            case "3":
              this.createType = "sm_object";
              break;
            case "4":
              this.createType = "ys_sm_object";
              break;
            case "5":
              this.createType = "jt_object";
              break;
          }
        }
      );
    } else {
      this.createType = "object";
    }
  },
  mounted() {
    // 获取项目组
    this.getTeam();
    // 获取项目列表
    this.getProject();
  },
  components: {
    Create1,
    Create2,
    Create3,
    Create4,
    Create5,
    Create6,
  },
  methods: {
    // 获取项目组
    getTeam() {
      ajax.post(
        "/gc/project/team/list",
        {
          depId: this.userData.secDepIds.split(",")[0],
        },
        (res) => {
          this.teamArr = res.vo.array;
        }
      );
    },
    // 获取项目列表
    getProject() {
      ajax.get(
        "/gc/project/parent/list",
        {
          depId: "",
        },
        (res) => {
          this.projectArr = res.vo.array;
        }
      );
    },
  },
  watch: {
    $route() {
      this.hasApplyId = this.$route.params.applyId ? true : false;
    },
    objectType() {
      if (!this.hasApplyId) {
        if (this.objectType == "B") {
          this.createType = "sm_object";
        } else {
          this.createType = "object";
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/create.vue